import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import {
  DvSplitterEventsService,
  DvSplitterResizableSide,
  DvVerticalSplitterComponent,
} from '@devinco/ui/dds/splitter';
import { DamageReportsGridComponent } from './components/damage-reports-grid/damage-reports-grid.component';
import { DirectivesModule } from '@shared/directives/directives.module';
import { UpperCasePipe } from '@angular/common';
import { DvButtonComponent } from '@devinco/ui/dds';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  imports: [
    DamageReportsGridComponent,
    DvVerticalSplitterComponent,
    RouterOutlet,
    DirectivesModule,
    UpperCasePipe,
    DvButtonComponent,
    TranslateModule,
    RouterLink,
  ],
  selector: 'app-damage-reports-page',
  templateUrl: './damage-reports-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['../../styles/page.scss'],
})
export class DamageReportsPageComponent {
  private splitterEvents = inject(DvSplitterEventsService);

  readonly resizableSide = DvSplitterResizableSide;

  onCreateClick(): void {
    this.splitterEvents.isSplitterOpened$.next(true);
  }
}
